import * as React from "react";
const SvgVideo = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.242 6.036a.75.75 0 0 0-.514.928l1.075 3.748a.757.757 0 0 0-.001.044v12c0 .414.335.75.75.75h20a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-.75-.75H7.353l14.63-4.195a.75.75 0 0 0 .515-.928l-1.103-3.845a.75.75 0 0 0-.927-.514L1.242 6.036Zm1.824 3.639-.69-2.403L8.05 5.645 6.335 8.737l-3.27.938Zm5.309-1.523 1.713-3.092 5.307-1.522-1.713 3.093-5.307 1.521Zm7.346-2.106 5.128-1.47-.689-2.404-2.726.782-1.713 3.092ZM3.3 15.352v2.5h18.5v-2.5h-18.5Zm5.481-1.5h5.521l2.347-2.346h-5.52l-2.348 2.346Zm13.02 0h-5.377l2.346-2.346h3.03v2.346Zm-15.14 0 2.346-2.346H3.302v2.346h3.36Zm-3.36 8.154v-2.654h8.5v2.654h-8.5Zm10 0v-2.654h8.5v2.654h-8.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgVideo;
